import { camelCase } from 'lodash-es'
export default function (job) {
  return {
    id: job.id,
    title: job.title,
    description: job.description,
    jobKey: camelCase(job.title),
  }
}
